<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-squidtoon">
      <div class="px-3 col-3 p-0">
        <div class="heading-squidtoon">{{ $t('result.round') }}</div>
        <div class="text-subhead-squidtoon">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-squidtoon">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-squidtoon">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-squidtoon">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-squidtoon">{{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-squidtoon">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-squidtoon">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-squidtoon pt-3">
      <div class="text-games-squidtoon">{{ 'Squid toon' }}</div>
      <div class="text-subgame-squidtoon">{{ $t("squidtoon.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 100px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white;">
          <i v-if="isFreespin || isRespin || isBonus" class="fas fa-caret-left arrow-side-squidtoon"
            @click="delCount()"></i>
        </div>
        <section v-if="state === 'BONUSGAME'">
          <div v-if="state === 'BONUSGAME'" class="">
            <div v-if="bonusGame.id === 'AEIOU'">
              <div v-if="bonusGame.amount > 0">
                <div class="">
                  <img class="multiplier-image" width="100%"
                    :src="require(`../../assets/resultGame/squidgame/popup_win.png`)" alt="">
                </div>
                <div v-if="bonusGame.round > 1" class="">
                  <img class="multiplier-label"
                    :src="require(`../../assets/resultGame/squidgame/multiplier_${bonusGame.history[bonusGame.round - 1].multiplier}_${lang}.png`)" />
                </div>
                <div v-else-if="bonusGame.round < 2" class="">
                  <img class="multiplier-label"
                    :src="require(`../../assets/resultGame/squidgame/multiplier_${bonusGame.multiplier}_${lang}.png`)" />
                </div>
                <span class="multiplier-value">
                  {{ `X${bonusGame.multiplier}` }}
                </span>
                <span class="aeiou-amount">
                  {{ bonusGame.amount | currencyFormatter }}
                </span>
              </div>
              <div v-else-if="bonusGame.amount <= 0">
                <img class="multiplier-image" width="100%"
                  :src="require(`../../assets/resultGame/squidgame/popup_lose.png`)" alt="">
              </div>
            </div>
            <div v-if="bonusGame.id === 'TUGOFWAR'">
              <img class="multiplier-image" width="100%"
                :src="require(`../../assets/resultGame/squidgame/tow_${bonusGame.result}.png`)" alt="">
            </div>
          </div>
        </section>
        <section v-else-if="state === 'SPIN' || state === 'RESPIN' || state === 'FREESPIN' || state === 'FREERESPIN'">
          <div class="table-squidtoon container d-flex flex-column justify-content-center">
            <table>
              <tbody>
                <tr v-for="(row, index) in reels[0]" :key="index">
                  <td v-for="(col, i) in reels" :key="`${index}${i}`">
                    <img class="icon-symbol-squidtoon"
                      :src="require(`../../assets/resultGame/squidgame/symbol_${col[index]}.png`)" alt="">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-squidtoon" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-squidtoon">
        <h1 v-if="isFreespin"> {{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        <h1 v-else-if="isBonus"> {{ $t("result.bonus") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        <h1 v-else> {{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-else-if="winnings === undefined">

      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-squidtoon">{{ $t("featurebuy.title") }}</div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-box-squidtoon p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-squidtoon item justify-content-center">
                <div class="d-flex justify-content-start bet-wrapper-squidtoon item">
                  <img class="icon-detail-squidtoon"
                    :src="require(`../../assets/resultGame/squidgame/symbol_${detail.symbol}.png`)" alt="">
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                    <!-- <p> {{ `${detail.count} ` }}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="winnings.length === 0 && state === 'BONUSGAME'" class="justify-content-center">
        <div class="bet-box-squidtoon p-2 px-3 justify-content-center">
          <div class="bet-warpper item justify-content-center">
            <div class="d-flex item  px-1 mb-2">
              <div class="bet-wrapper-squidtoon item justify-content-center">
                <div v-if="bonusGame.id === 'TUGOFWAR'"
                  class="d-flex  bet-wrapper-squidtoon item justify-content-start">
                  <img class="icon-detail-squidtoon"
                    :src="require(`../../assets/resultGame/squidgame/tow_${bonusGame.result}.png`)" alt="">
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ bonusGame.amount | currencyFormatter }}</p>
                  </div>
                </div>
                <div v-else-if="bonusGame.id === 'AEIOU'"
                  class="d-flex  bet-wrapper-squidtoon item justify-content-start">
                  <img class="icon-detail-squidtoon" :src="require(`../../assets/resultGame/squidgame/aeiou_${bonusGame.result === 3 ? 0 : bonusGame.result === 4 ? 1 : 0
                    }.png`)" alt="">
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ bonusGame.amount | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-squidtoon',
  props: {
    data: Object,
    lang: String,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      reels: [],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      isEndRound: false,
      pages: 0,
      state: '-',
      nextState: '-',
      multiplierReel: null,
      isBonus: false,
      symbolsBonus: null,
      bonusGame: null,

    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-squidtoon')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isRespin = result.state === 'RESPIN'
      this.isBonus = result.state === 'BONUSGAME'
      this.state = result.state;
      this.nextState = result.nextState;
      this.symbolsBonus = this.data.detail.bonusWin

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.multiplierReel = result.multiplierReels;
      if (result.winnings === undefined) {
        this.winnings = [];
      }
      this.bonusGame = result.bonusGame;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}

</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933
    /* margin: 0; */
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-squidtoon {
  width: 100px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-squidtoon {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-squidtoon {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-squidtoon {
  background: #F44786;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.bonus-box-squidtoon {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-squidtoon .item {
  color: #000;
  background: #FFCC2E;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-squidtoon .bet-wrapper-squidtoon:not(:first-child) .item {
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
}

.bet-wrapper-squidtoon,
.result-wrapper {
  font-size: 35px;
}

.header-squidtoon {
  background: #FFC7D0;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-squidtoon>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-squidtoon {
  color: #000000;
  text-align: center;
}

.content-result-squidtoon {
  background: #AA3040;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-squidtoon {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-squidtoon {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-squidtoon {
  font-size: px;
  color: #5A5A5A;
  text-align: center;
}

.text-subgame-squidtoon {
  font-size: 20px;
  color: #FFD500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #FFF5BF;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-squidtoon {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-squidtoon {
  min-width: 600px;
  max-width: auto;
}

.multiplier-label {
  position: absolute;
  top: 7%;
  right: 46%;
  left: 23%;
  width: 23%;
  color: #007bff;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
}

.multiplier-value {
  position: absolute;
  top: 18%;
  right: 53%;
  left: 33%;
  width: 23%;
  font-size: 107px;
  color: #007bff;
  transform: rotate(-13deg);
  font-weight: 900;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
}

.aeiou-amount {
  font-size: 109px;
  top: 70%;
  left: 38%;
  right: 0%;
  bottom: 0%;
  position: absolute;
  font-weight: 900;
  color: #007bff;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
  ;
}

.table-squidtoon {
  background: url("~@/assets/resultGame/squidgame/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 570px 390px;
  /* set Bg Table HERE */
  width: 570px;
  height: 390px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-squidtoon {
    background-size: 500px 328px;
    width: 500px;
    height: 328px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }


  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-squidtoon {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-squidtoon,
  .result-wrapper {
    font-size: 35px;
  }

  .multiplier-label {
    top: 11%;
    left: 19%;
  }

  .multiplier-value {
    font-size: 100px;
    top: 21%;
    left: 29%;
  }

  .aeiou-amount {
    font-size: 109px;
    top: 65%;
    left: 36%;
  }
}

@media screen and (min-width: 1060px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-squidtoon,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #98134D;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

.multiplier-label {
  width: 20%;
  top: 3%;
  left: 27%;
}

.multiplier-value {
  left: 36%;
}

.aeiou-amount {
  left: 43%;
}

@media screen and (max-width: 770px) {
  .heading-squidtoon {
    font-size: 18px;
  }

  .table-squidtoon {
    background-size: 470px 329px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .multiplier-label {
    top: 10%;
    left: 18%;
  }

  .multiplier-value {
    font-size: 65px;
    top: 18%;
    left: 27%;
  }

  .aeiou-amount {
    font-size: 85px;
    top: 66%;
    left: 36%;

  }

  .front-table-squidtoon {
    background: url('~@/assets/resultGame/squidgame/slotmachine.png') no-repeat;
    background-size: 470px 329px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-squidtoon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-squidtoon {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }


  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-squidtoon>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-squidtoon {
    font-size: 12px;
  }

  .table-squidtoon {
    background-size: 250px 180px;
    width: 250px;
    height: 180px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-squidtoon {
    font-size: 14px;
  }

  .bet-box-squidtoon {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-squidtoon {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-squidtoon,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-squidtoon {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-squidtoon {
    width: 60px;
    height: 60px;
  }
}
</style>